import { useRouter } from '@tanstack/react-router';
import { generatePath } from '@/services/router/generate-path';

/**
 * Where an item's "make one" links go: a new snippet seeded with the item,
 * and the layout starters, which is where a template or a layout is begun.
 *
 * Spelled as the page this replaces spells them (`utils/snippets.ts`
 * `newSnippetUrl`, `utils/layouts.ts` `layoutsStartersUrl`), without the
 * `journeys` segment.
 */
export function useCreateHrefs(workspaceId: number, itemId: string) {
  const router = useRouter();
  const params = { workspaceId: String(workspaceId) };

  return {
    // `generatePath`, not `buildLocation`: the router writes search values
    // through `JSON.stringify`, which would quote an attribute named `123`.
    snippet: generatePath('/workspaces/:workspaceId/snippets/new', params, { attribute: itemId }),
    starters: router.buildLocation({ to: '/workspaces/$workspaceId/layouts/starters', params }).href,
  };
}
